/// <reference types="vite/client" />
var env;
var NODE_ENV;
var LOCIZE_PROJECT_ID = '8e532bc2-ae28-4290-8a86-071c4dbb904d';
var LOCIZE_API_KEY = '';
var LOCIZE_VERSION = 'stable'; // In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  NODE_ENV = "production";
  if (process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID) LOCIZE_PROJECT_ID = process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID;

  if (NODE_ENV === 'development') {
    LOCIZE_API_KEY = '14a739ea-9e6e-488d-8ab0-d835b873b9b6';
    LOCIZE_VERSION = 'latest';
  }
} else if (import.meta !== undefined) {
  env = import.meta.env;
  NODE_ENV = env.MODE;
  if (env.VITE_PUBLIC_LOCIZE_PROJECT_ID) LOCIZE_PROJECT_ID = env.VITE_PUBLIC_LOCIZE_PROJECT_ID;

  if (NODE_ENV === 'development') {
    LOCIZE_API_KEY = '14a739ea-9e6e-488d-8ab0-d835b873b9b6';
    LOCIZE_VERSION = 'latest';
  }
} else {
  throw 'No env found';
}

export { LOCIZE_API_KEY, LOCIZE_PROJECT_ID, LOCIZE_VERSION };